export default __webpack_public_path__ + "static/4-90d84dcc3a5af72fbf4234fe69c9811e.webp";